export const PLATFORM_INTERFACE_LOCALES = Object.freeze(['en', 'ar']);

const ARABIC_SCRIPT_PATTERN = /[\u0600-\u06ff]/;
const INTL_LOCALES = Object.freeze({
  ar: 'ar-EG',
  en: 'en-US',
});

export const normalizePlatformLocale = value => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase()
    .split(/[-_]/)[0];
  return PLATFORM_INTERFACE_LOCALES.includes(normalized) ? normalized : 'en';
};

export const platformIntlLocale = value =>
  INTL_LOCALES[normalizePlatformLocale(value)];

export const platformTextDirection = value =>
  normalizePlatformLocale(value) === 'ar' ? 'rtl' : 'ltr';

export const platformLocaleResource = (value, resources) =>
  resources[normalizePlatformLocale(value)] ?? resources.en;

export const applyPlatformDocumentLocale = value => {
  const normalizedLocale = normalizePlatformLocale(value);

  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalizedLocale;
    document.documentElement.dir = platformTextDirection(normalizedLocale);
  }
};

const humanizePlanCode = value => {
  const words = String(value || '')
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');
  if (!words) return '';
  return words.replace(/\b\p{L}/gu, character => character.toUpperCase());
};

export const localizedPlanName = ({
  locale,
  name,
  nameAr,
  nameEn,
  code,
  fallback,
}) => {
  const normalizedLocale = normalizePlatformLocale(locale);
  const legacyName = String(name || '').trim();
  const arabicName = String(nameAr || legacyName).trim();
  const englishName = String(nameEn || '').trim();
  const planCode = humanizePlanCode(code);

  if (normalizedLocale === 'ar') {
    return arabicName || englishName || planCode || fallback;
  }
  if (englishName) return englishName;
  if (planCode) return planCode;
  if (legacyName && !ARABIC_SCRIPT_PATTERN.test(legacyName)) return legacyName;
  return fallback;
};
